import React, { useEffect } from "react";
import { Pagination, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useShipmentModel } from "../shipmentModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { IShipmentDetail } from "../shimentTypes";
import { formatNum ,momentFormat} from "@/utils/utils";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys
    } = useShipmentModel();
    const { getTreeNodeName } = useDictModel(() => []);

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<IShipmentDetail> = [
        {
            title: '序号',
            width: 45,
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '外贸合同号',
            width: 160,
            dataIndex: 'saleRealCode',
            fixed: "left",
        }, {
            title: '发运单号',
            width: 160,
            dataIndex: 'code',
            fixed: "left",
            render: t => t === "listTotalAmount" ? "" : t
        }, {
            title: '状态',
            width: 120,
            dataIndex: 'status',
            render: text => getTreeNodeName(text)
        }, {
            title: '支付状态',
            width: 120,
            dataIndex: 'detailsAdd',
            render: list => {
                if (list && list.length) {
                    return list.find((item: { status: string; }) => item.status === "shipment.pend-settle") ? "待结算" : "已结算"
                }
                return "";
            }
        }, {
            title: '客户名称',
            width: 160,
            dataIndex: "customerName",
            render: text => <p className="ellipsis" title={text}>{text}</p>
        },
        // {
        //     title: '出运日期',
        //     width: 180,
        //     dataIndex: "deliveryTime"
        // }, 
        {
            title: '币种',
            width: 100,
            dataIndex: 'currencyName',
        }, {
            title: '数量',
            width: 100,
            dataIndex: 'typeNum',
        }, {
            title: '合同金额',
            width: 100,
            dataIndex: 'contractAmount',
            render: (t, r) => `${r.currency ?? ""}${formatNum(t)}`
        }, {
            title: '附加费',
            width: 100,
            dataIndex: 'addAmount',
            render: (t, r) => `${r.currency ?? ""}${formatNum(t)}`
            // render: (t, r) => typeof r.detailsAdd === "object" ? formatNum(r.detailsAdd?.reduce((con, next) => { con += +(next.amount ?? 0); return con }, 0) ?? 0) : ""
        }, {
            title: '国别地区',
            width: 140,
            dataIndex: 'countryName',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
            render: text => <p className="ellipsis" title={text}>{text}</p>
        }, {
            title: '创建人',
            width: 100,
            dataIndex: 'createUser',
        }, {
            title: '创建时间',
            width: 180,
            dataIndex: 'createTime',
            render: t => momentFormat(t, "YYYY-MM-DD")
        }
    ];


    //点击行选高亮
    const onRow = (code: string) => {
        if (code === "listTotalAmount") return;
        let findIndex = selectedRowKeys.indexOf(code);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(code);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    const getTotalTow = (dataSource: IShipmentDetail[]): IShipmentDetail => {
        let typeNum: number = 0;
        let contractAmount: number = 0;
        let addAmount: number = 0;
        dataSource.forEach(item => {
            typeNum += +(item?.typeNum ?? 0)
            contractAmount += +(item?.contractAmount ?? 0)
            addAmount += +(item?.addAmount ?? 0)
        })
        return {
            code: "listTotalAmount",
            totalTxt: "合计:",
            id: "",
            goodsAmount: "", exchangeRate: "",
            typeNum,
            contractAmount: formatNum(contractAmount),
            addAmount: formatNum(addAmount)
        }
    }
    return (
        <>
            <Table
                rowKey={record => record.code}
                loading={loading}
                rowSelection={{
                    //全部选中时  (存string[])
                    getCheckboxProps: (record) => {
                        let checkboxProps: any = {};
                        if (record.code === "listTotalAmount") {
                            checkboxProps.disabled = true;
                        }
                        return checkboxProps;
                    },
                    onSelectAll: (selected, selectedRows, changeRows) => {
                        let changeRowId = changeRows.map(item => item.code).filter(item => item !== "listTotalAmount");
                        selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                            : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                    },
                    onSelect: (record) => onRow(record.code),
                    selectedRowKeys: selectedRowKeys
                }}
                columns={columns}
                dataSource={dataSource.length > 0 ? [...dataSource, getTotalTow(dataSource)] : []}
                // pagination={{
                //     ...pgCfg,
                //     position: ["bottomCenter"],
                //     showTotal: () => `共${pgCfg.total}条`,
                //     onChange: (pageNum, pageSize) => {
                //         loadData({ pageNum, pageSize })
                //     }
                // }}
                pagination={false}
                onRow={record => ({
                    onClick: () => onRow(record.code),
                    onContextMenu: (e) => {
                        e.preventDefault();
                        setSelectedRowKeys([record.code]);
                    }
                })}
                scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
            />
            <div style={{
                margin: "5px",
                display: "flex",
                justifyContent: "center"
            }}>
                {dataSource.length > 0 ? <Pagination  {...{
                    ...pgCfg,
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    }
                }} /> : <></>}
            </div>
        </>
    )
}
